<template>
    <div class="m-5 md:m-15 2xl:m-20" @keydown="progressbar.userKeyDown()" @keyup="progressbar.userKeyUp()" @click="calculate_progress">

        <h3 class="mb-5 md:mb-15 2xl:mb-20">Poste de travail</h3>

        <div class=" grid grid-cols-12 gap-x-4 gap-y-10">
            <!-- BEGIN Postures pénibles -->
            <div class="col-span-full text-base text-indigo-600  ">POSTURES PENIBLES</div>

            <input-select
                name="type_posture"
                libelle="Type de posture"
                :necessary="true"
                :value="form.type_posture" @input="(newValue) => {form.type_posture = newValue;}"
                :datas="[
                    { value: 'Assis seulement' },
                    { value: 'Debout seulement' },
                    { value: 'Alternance assis-debout' },
                    { value: 'Accroupis' },
                    { value: 'A genoux' },
                    { value: 'Penché' },
                    { value: 'Rotations' },
                    { value: 'Bras tendus' },
                    { value: 'Bras levés' },
                    { value: 'Flexion/Extension du poignet' },
                    { value: 'Autres' },
                ]"
                class="md:col-span-6"
            />
            <transition
                enter-active-class="ease-in duration-300"
                enter-class="opacity-0"
                leave-active-class="ease-out duration-300"
                leave-to-class="opacity-0"
            >
                <input-text
                    v-if="form.type_posture === 'Autres'"
                    name="type_posture_precis"
                    libelle="Précisez (si autres)"
                    :necessary="true"
                    :value="form.type_posture_precis" @input="(newValue) => {form.type_posture_precis = newValue;}"
                    class="md:col-span-6"
                />
            </transition>

            <input-text-area
                name="type_posture_comment"
                libelle="Commentaires"
                :necessary="false"
                :value="form.type_posture_comment" @input="(newValue) => {form.type_posture_comment = newValue;}"
                class="md:col-span-full"
                size=3
            />
            <!-- END Postures pénibles -->

            <!-- BEGIN Manipulations -->
            <div class="col-span-full text-base text-indigo-600 mt-10">MANIPULATIONS</div>
            
            <multiple-select
                name="type_manipulations"
                libelle="Type de manipulations"
                :necessary="true"
                :value="form.type_manipulations" @input="(newValue) => {form.type_manipulations = newValue;}"
                :datas="[
                    {value: 'Mono-manuelle' },
                    {value: 'Bi-manuelle' },
                    {value: 'Motricité fine' },
                    {value: 'Maintien de la main en position de supînation (rotation des paumes vers le haut)'},
                    {value: 'Maintien de la main en posture de pronation (rotation des paumes vers le bas)'},
                    {value: 'Autres' },
                ]"
                class="md:col-span-6"
            />

            <transition
                enter-active-class="ease-in duration-300"
                enter-class="opacity-0"
                leave-active-class="ease-out duration-300"
                leave-to-class="opacity-0"
            >
                <input-text
                    v-if="form.type_manipulations.includes('Autres')"
                    name="type_manipulations_precis"
                    libelle="Précisez (si autres)"
                    :necessary="true"
                    :value="form.type_manipulations_precis" @input=" (newValue) => {form.type_manipulations_precis = newValue;}"
                    class="md:col-span-6"
                />
            </transition>

            <input-text-area
                name="type_manipulations_comment"
                libelle="Commentaires"
                :necessary="false"
                :value="form.type_manipulations_comment" @input="(newValue) => {form.type_manipulations_comment = newValue;}"
                class="md:col-span-full"
                size=3
            />
            <!-- END Manipulations -->

            <!-- BEGIN Contraintes d'exposition -->
            <div class="col-span-full text-base text-indigo-600 mt-10">CONTRAINTES D'EXPOSITION</div>
            
            <multiple-select
                name="type_contraintes"
                libelle="Type de contraintes"
                :necessary="true"
                :value="form.type_contraintes" @input="(newValue) => {form.type_contraintes = newValue;}"
                :datas="[
                    { value: 'Absences de contraintes d\'exposition' },
                    { value: 'Contraintes alimentaires' },
                    { value: 'Contraintes liées à l\'exposition au froid' },
                    { value: 'Contraintes liées à l\'exposition à la chaleur' },
                    { value: 'Contraintes liées à l\'exposition aux intempéries' },
                    { value: 'Contraintes liées à l\'exposition à l\'humidité' },
                    { value: 'Contraintes liées à l\'exposition aux poussières' },
                    { value: 'Contraintes liées à l\'exposition aux agents chimiques' },
                    { value: 'Contraintes liées à l\'exposition aux agents infectieux',},
                    { value: 'Contraintes liées à l\'exposition au stress' },
                    { value: 'Contraintes liées à l\'exposition au bruit' },
                    { value: 'Contraintes liées à l\'exposition à la luminosité' },
                    { value: 'Contraintes liées à l\'exposition à la foule' },
                    { value: 'Autres contraintes' },
                ]"
                class="md:col-span-6"
            />

            <transition
                enter-active-class="ease-in duration-300"
                enter-class="opacity-0"
                leave-active-class="ease-out duration-300"
                leave-to-class="opacity-0"
            >
                <input-text
                    v-if="form.type_contraintes.includes('Autres contraintes')"
                    name="type_contraintes_precis"
                    libelle="Précisez (si autres)"
                    :necessary="true"
                    :value="form.type_contraintes_precis" @input="(newValue) => {form.type_contraintes_precis = newValue;}"
                    class="md:col-span-6"
                />
            </transition>

            <input-text-area
                name="type_contraintes_comment"
                libelle="Commentaires"
                :necessary="false"
                :value="form.type_contraintes_comment" @input="(newValue) => {form.type_contraintes_comment = newValue;}"
                class="md:col-span-full"
                size=3
            />
            <!-- END Contraintes d'exposition -->

            <!-- BEGIN Déplacement dans l'environnement de travail -->
            <div class="col-span-full text-base text-indigo-600 mt-10">DEPLACEMENT DANS L'ENVIRONNEMENT DE TRAVAIL</div>
            
            <input-select
                name="deplacement_sans_port_charges"
                libelle="Déplacement sans port de charges"
                :necessary="true"
                :value="form.deplacement_sans_port_charges" @input="(newValue) => {form.deplacement_sans_port_charges = newValue;}"
                :datas="[
                    { value: 'Oui' },
                    { value: 'Non' },
                ]"
                class="md:col-span-3"
            />

            <input-text
                name="deplacement_sans_port_charges_duree"
                libelle="Durée"
                :necessary="true"
                :value="form.deplacement_sans_port_charges_duree" @input="(newValue) => {form.deplacement_sans_port_charges_duree = newValue;}"
                class="md:col-span-3"
            />

            <input-text
                name="deplacement_sans_port_charges_frequence"
                libelle="Fréquence"
                :necessary="true"
                :value="form.deplacement_sans_port_charges_frequence" @input="(newValue) => {form.deplacement_sans_port_charges_frequence = newValue;}"
                class="md:col-span-3"
            />

            <input-select
                name="deplacement_avec_port_charges"
                libelle="Déplacement avec port de charges"
                :necessary="true"
                :value="form.deplacement_avec_port_charges" @input="(newValue) => {form.deplacement_avec_port_charges = newValue;}"
                :datas="[
                    { value: 'Oui' },
                    { value: 'Non' },
                ]"
                class="lg:col-start-1 md:col-span-3"
            />

            <input-text
                name="deplacement_avec_port_charges_duree"
                libelle="Durée"
                :necessary="true"
                :value="form.deplacement_avec_port_charges_duree" @input="(newValue) => {form.deplacement_avec_port_charges_duree = newValue;}"
                class="md:col-span-3"
            />

            <input-text
                name="deplacement_avec_port_charges_frequence"
                libelle="Fréquence"
                :necessary="true"
                :value="form.deplacement_avec_port_charges_frequence" @input="(newValue) => {form.deplacement_avec_port_charges_frequence = newValue;}"
                class="md:col-span-3"
            />

            <input-text
                name="deplacement_avec_port_charges_poids"
                libelle="Poids maximum"
                :necessary="true"
                :value="form.deplacement_avec_port_charges_poids" @input="(newValue) => {form.deplacement_avec_port_charges_poids = newValue;}"
                class="md:col-span-3"
            />

            <input-text-area
                name="deplacement_environnement_travail_comment"
                libelle="Commentaires"
                :necessary="false"
                :value="form.deplacement_environnement_travail_comment" @input="(newValue) => {form.deplacement_environnement_travail_comment = newValue;}"
                class="md:col-span-full"
                size=3
            />
            <!-- END Déplacement dans l'environnement de travail -->

            <!-- BEGIN Plan de travail -->
            <div class="col-span-full text-base text-indigo-600 mt-10">PLAN DE TRAVAIL</div>
            
            <multiple-select
                name="plan_travail"
                libelle="Plan de travail"
                :necessary="true"
                :value="form.plan_travail" @input="(newValue) => {form.plan_travail = newValue;}"
                :datas="[
                    { value: 'Hauteur à respecter' },
                    { value: 'Assise à ajuster' },
                    { value: 'Champ visuel à respecter'},
                ]"
                class="md:col-span-4"
            />

            <input-text
                name="condition_eclairage_spe"
                libelle="Condition d'éclairage spécifique"
                :necessary="true"
                :value="form.condition_eclairage_spe" @input="(newValue) => {form.condition_eclairage_spe = newValue;}"
                class="md:col-span-4"
            />

            <input-text
                name="condition_eclairage_spe_precis"
                libelle="Précisez"
                :necessary="false"
                :value="form.condition_eclairage_spe_precis" @input="(newValue) => {form.condition_eclairage_spe_precis = newValue;}"
                class="md:col-span-4"
            />

            <input-text-area
                name="plan_travail_comment"
                libelle="Commentaires"
                :necessary="false"
                :value="form.plan_travail_comment" @input="(newValue) => {form.plan_travail_comment = newValue;}"
                class="md:col-span-full"
                size=3
            />
            <!-- END Plan de travail -->

            <!-- BEGIN Aménagement informatique -->
            <div class="col-span-full text-base text-indigo-600 mt-10">AMENAGEMENT INFORMATIQUE</div>
            <multiple-select
                name="amenagement_informatique"
                libelle="Aménagement informatique"
                :necessary="true"
                :value="form.amenagement_informatique" @input="(newValue) => {form.amenagement_informatique = newValue;}"
                :datas="[
                    { value: 'PC fixe' },
                    { value: 'PC portable' },
                    { value: 'Double écrans'},
                    { value: 'Verticalisateur de documents'},
                    { value: 'Souris/ Clavier sans fil'},
                    { value: 'Souris spécifique'},
                    { value: 'Clavier spécifique'},
                    { value: 'Réglage écran (Contraste / Couleurs)'},
                    { value: 'Réglages caractères'},
                    { value: 'Réglages environnement (Windows, Mac...)'}
                ]"
                class="md:col-span-4"
            />

            <input-text
                name="amenagement_informatique_precis"
                libelle="Précisez"
                :necessary="false"
                :value="form.amenagement_informatique_precis" @input="(newValue) => {form.amenagement_informatique_precis = newValue;}"
                class="md:col-span-4"
            />

            <input-text
                name="taille_ecran_min"
                libelle="Taille écran minimum"
                :necessary="true"
                :value="form.taille_ecran_min" @input="(newValue) => {form.taille_ecran_min = newValue;}"
                class="md:col-span-4"
            />
            
            <input-text-area
                name="amenagment_informatique_comment"
                libelle="Commentaires"
                :necessary="false"
                :value="form.amenagment_informatique_comment" @input="(newValue) => {form.amenagment_informatique_comment = newValue;}"
                class="md:col-span-full"
                size=3
            />
            <!-- END Aménagement informatique -->

            <!-- BEGIN Adaptation des documents -->
            <div class="col-span-full text-base text-indigo-600 mt-10">ADAPTATION DES DOCUMENTS</div>
            
            <multiple-select
                name="adaptation_documents"
                libelle="Adaptation des documents"
                :necessary="true"
                :value="form.adaptation_documents" @input="(newValue) => {form.adaptation_documents = newValue;}"
                :datas="[
                    { value: 'Agrandissement format de document' },
                    { value: 'Contraste / Couleurs'},
                    { value: 'Surlignage des titres'},
                    { value: 'Supports aérés'},
                ]"
                class="md:col-span-4"
            />

            <input-text
                name="adaptation_document_precis"
                libelle="Précisez"
                :necessary="false"
                :value="form.adaptation_document_precis" @input="(newValue) => {form.adaptation_document_precis = newValue;}"
                class="md:col-span-4"
            />

            <input-text
                name="taille_caracteres"
                libelle="Taille des caractères"
                :necessary="true"
                :value="form.taille_caracteres" @input="(newValue) => {form.taille_caracteres = newValue;}"
                class="md:col-span-4"
            />

            <input-text-area
                name="adaptation_documents_comment"
                libelle="Commentaires"
                :necessary="false"
                :value="form.adaptation_documents_comment" @input="(newValue) => {form.adaptation_documents_comment = newValue;}"
                class="md:col-span-full"
                size=3
            />
            <!-- END Adaptation des documents -->
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import InputText from '../../../components/Inputs/InputText';
import InputTextArea from '../../../components/Inputs/InputTextArea';
import InputSelect from '../../../components/Inputs/InputSelect';
import MultipleSelect from '../../../components/Inputs/MultipleSelect';
import DatePicker from '../../../components/Inputs/DatePicker';
import CheckboxGreen from '../../../components/Inputs/CheckboxGreen';
import CheckboxForm from '../../../components/Inputs/CheckboxForm';
import Icon from '../../../components/Icon';

export default {
  components: {
    InputText,
    InputTextArea,
    InputSelect,
    MultipleSelect,
    DatePicker,
    CheckboxGreen,
    CheckboxForm,
    Icon
  },

  props:['progressbar'],

  name: 'Postedetravail',

  data() {
    return {
      // Initial state of the form
      form: {
        type_posture: '',
        type_posture_precis: '',
        type_posture_comment: '',
        type_manipulations: [],
        type_manipulations_precis: '',
        type_manipulations_comment: '',
        type_contraintes: [],
        type_contraintes_precis: '',
        type_contraintes_comment: '',
        deplacement_sans_port_charges:'',
        deplacement_sans_port_charges_duree:'',
        deplacement_sans_port_charges_frequence:'',
        deplacement_avec_port_charges:'',
        deplacement_avec_port_charges_duree:'',
        deplacement_avec_port_charges_frequence:'',
        deplacement_avec_port_charges_poids:'',
        deplacement_environnement_travail_comment:'',
        plan_travail:[],
        condition_eclairage_spe:'',
        condition_eclairage_spe_precis:'',
        plan_travail_comment:'',
        amenagement_informatique:[],
        amenagement_informatique_precis:'',
        taille_ecran_min:'',
        amenagment_informatique_comment:'',
        adaptation_documents:[],
        adaptation_document_precis:'',
        taille_caracteres:'',
        adaptation_documents_comment:''
      },
    };
  },

  async mounted() {
    await this.initForm(); // asynchrone function to wait do actions, then re-pass isFormChanged to false (actions in form pass this var to true)
    this.calculate_progress();
    this.infosPage.isFormChanged = false; // here, change value of isFormChanged to false to indicate that there is not change in form
  },

  methods: {
    ...mapMutations({
      SET_FORMCONTENT: 'neopass/SET_FORMCONTENT',
      calculate_progress: 'neopass/calculate_progress',
      SET_INFOSPAGES: 'neopass/SET_INFOSPAGE',
    }),

    initForm(){
      //load values in form and keep formContent with initial values to compare when leave page without saving
      Object.assign(this.form, this.formContent);
    },
  },
  computed: {
    ...mapGetters({
      formContent: 'neopass/formContent',
      infosPage: 'neopass/infosPage',
    }),
  },
  watch: {
    form: {
      handler() {
        //assign true to flag to know if there is a change in form
        this.infosPage.isFormChanged = true;
      },
      deep: true,
    },
  },
};
</script>
